@if (src && !rounded) {
<div class="custom-background-img overflow-hidden" [style.background-color]="backgroundColor || ''"
  [style.background-image]="'url('+src+')'"></div>
}

@if (rounded) {
<div class="border border-primary listing-inn shadow-lg rounded-xl w-full h-full
       bg-white cursor-pointer overflow-hidden relative">
  <div class="custom-background-img absolute inset-0" [style.background-color]="backgroundColor || ''"
    [style.background-image]="'url('+src+')'"></div>
</div>
}